module.exports = __webpack_public_path__ + "static/img/logo_only.b1b915f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_only.png
// module id = M9rd
// module chunks = 1